<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/projects' }" style="color: #5daf34">{{ this.projectName }}</el-breadcrumb-item>
      <el-breadcrumb-item></el-breadcrumb-item>
    </el-breadcrumb>


    <div>
      <div style="float: left;">
        <h1> 服务列表</h1>
      </div>

      <div style="float: right;">
        <el-button icon="el-icon-plus" type="primary" @click="initAdd">添加新服务</el-button>
      </div>
    </div>


    <br/>
    <br/>
    <br/>


    <el-table
        :data="tableData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%;">

      <el-table-column
          prop="name"
          label="服务名"
          width="150">
        <template scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column
          prop="ownerName"
          label="服务创建者"
          width="140">
      </el-table-column>
      <el-table-column
          prop="description"
          label="服务描述"
          width="200">
      </el-table-column>

      <el-table-column
          prop="token"
          label="服务token"
          width="300">
      </el-table-column>

      <el-table-column
          prop="createTime"
          label="服务创建时间"
          width="200">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>

      <el-table-column align="right">
        <template slot="header" slot-scope="{}">
          <el-input
              v-model="search"
              size="mini"
              placeholder="输入关键字搜索"/>
        </template>
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              plain
              @click="initEdit(scope.row,scope.$index)">编辑
          </el-button>
          <el-button
              size="mini"
              type="info"
              plain
              @click="rowClick(scope.row)">告警列表
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="服务信息更新" :visible.sync="formVisible">
      <el-form :model="form">
        <el-form-item label="服务id" :label-width="formLabelWidth" v-show="inputVisible">
          <el-input v-model="form.id" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="服务名称" :label-width="formLabelWidth" prop="serviceName">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="服务描述" :label-width="formLabelWidth" prop="serviceDescription">
          <el-input v-model="form.description" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="服务token" :label-width="formLabelWidth" v-show="inputVisible">
          <el-input v-model="form.token" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="服务创建者" :label-width="formLabelWidth" v-show="inputVisible">
          <el-input v-model="form.ownerName" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>

        <el-form-item label="服务创建时间" :label-width="formLabelWidth" v-show="inputVisible">
          <el-input v-model="form.createTime" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmHandler">保 存</el-button>
        <el-button
            v-if="form.id"
            type="danger"
            @click="deleteService">删 除
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {Apis} from "@/api";

export default {
  data() {

    return {
      tableData: [{
        id: "",
        name: "",
        description: "",

        token: "",

        ownerName: "",
        createTime: "",
      }],

      formLabelWidth: '120px',
      search: "",
      projectName: "",
      index: 0,
      formVisible: false,
      inputVisible: false,

      form: {
        id: "",
        name: "",
        description: "",
        ownerName: "",

        token: "",

        createTime: "",
      },
    }
  },
  methods: {

    //-----------------------------页面初始化函数----------------------------------//
    //添加页面 初始化
    initAdd() {
      //隐藏部分输入框
      this.inputVisible = false

      //不再隐藏表单弹窗
      this.formVisible = true

      //重置表单
      this.resetForm()
    },

    //编辑页面 初始化
    initEdit(row, index) {
      //不再隐藏部分框
      this.inputVisible = true

      //不再隐藏表单弹窗
      this.formVisible = true

      //重置表单
      this.resetForm()

      //填充数据 复制
      this.form = JSON.parse(JSON.stringify(row))
      this.form.index = index
    },

    //-------------------------------工具函数----------------------------------//
    resetForm() {
      this.form.id = ""
      this.form.name = ""
      this.form.description = ""
      this.form.ownerName = ""
      this.form.createTime = ""

      this.form.token = ""
    },

    //服务名点击事件 跳转到警报页面
    rowClick(row) {
      this.$route.params.serviceID = row.id;
      // console.log(this.$route.params.serviceID)
      this.$router.push({name: "Alerts"})
    },

    //----------------------------------前端函数----------------------------------------------//
    //弹窗界面确认按钮的处理函数
    async confirmHandler() {
      //保证输入不空
      if (this.form.name == "" || this.form.name == undefined) {
        this.$message.error("服务名称 不能为空");
        return
      }
      if (this.form.description == "" || this.form.description == undefined) {
        this.$message.error("服务描述 不能为空");
        return
      }
      //不同情况对应不同接口
      if (this.inputVisible === false) {
        //添加服务
        this.addService()

      } else {
        //更新服务
        this.updateService(this.form.index)
      }

      // 隐藏弹窗界面
      this.formVisible = false
    },


    //---------------------------------后端函数-------------------------------------------------//
    //删除服务
    async deleteService() {
      this.$confirm('此操作将永久删除服务以及服务下属的警报以及警报规则, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const response = await Apis.Service.deleteService(this.form.id)
        if (response != null && response.errno === 0) {
          this.$message.success("服务删除成功!");

          //前端列表中删除
          this.tableData.splice(this.form.index, 1)
          // 隐藏弹窗界面
          this.formVisible = false
        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //添加服务
    async addService() {
      const response = await Apis.Service.addService(this.form.name, this.form.description, parseInt(this.$route.params.projectID))
      if (response != null && response.errno === 0) {
        this.$message.success("服务信息添加成功!");

        //前端列表添加服务信息 列表头部添加
        const service = response.data;
        this.tableData.unshift({
          id: service.id,
          name: service.name,
          description: service.description,
          projectName: service.projectName,
          ownerName: service.ownerName,
          createTime: service.createTime,
          updateTime: service.updateTime,

          token: service.token,
        })
      }

    },

    //更新服务
    async updateService(index) {
      const response = await Apis.Service.updateService(this.form.id, this.form.name, this.form.description)
      if (response != null && response.errno === 0) {

        this.$message.success("服务信息更新成功");

        //先删除元素，然后将元素插入头部
        this.tableData.splice(index, 1)
        this.tableData.unshift(JSON.parse(JSON.stringify(this.form))) //复制一份form再传进去，避免form被重置之后列数据也被重置了，因为不复制的话传递的是引用


      }
    },
  },
  created: async function () {

    //初始化主页面
    this.tableData = []

    //通过路由参数解析得到projectID,从而得到服务列表
    const projectID = parseInt(this.$route.params.projectID);
    const response = await Apis.Service.getServices(projectID);

    //填充服务数据
    // console.log(services)

    this.tableData = response.data ?? []

    //通过projectID得到projectName
    const r = await Apis.Project.getProject(projectID)
    this.projectName = r.data.name

  }
}

</script>